import React from 'react';
import { GraduationCap } from 'lucide-react';

const COLORS = ['#F2B705', '#ffffff', '#14A3A3', '#F6EAF5', '#F2B705', '#E8A0E2'];
const PIECES = Array.from({ length: 48 }, (_, i) => ({
  left: `${(i * 37) % 100}%`, color: COLORS[i % COLORS.length], delay: `${(i % 12) * 0.25}s`, dur: `${3 + (i % 5) * 0.6}s`,
}));

export const GraduationCelebration = ({ onClose }) => (
  <div className="fixed inset-0 z-[80] bg-[#4c124a] text-white overflow-hidden flex items-center justify-center p-6" role="dialog" aria-modal="true" data-testid="hc-graduation-celebration">
    {PIECES.map((p, i) => (
      <span key={i} className="hc-grad-confetti" style={{ left: p.left, background: p.color, animationDelay: p.delay, animationDuration: p.dur }} />
    ))}
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(146,42,140,0.9),transparent_60%)]" />
    <div className="relative max-w-2xl text-center hc-pop">
      <div className="mx-auto w-28 h-28 rounded-full bg-white/10 ring-4 ring-[#F2B705] flex items-center justify-center">
        <GraduationCap className="w-14 h-14 text-[#F2B705]" />
      </div>
      <p className="mt-8 uppercase tracking-[0.3em] text-sm font-bold text-[#F2B705]">The HELP Institute</p>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold">You Graduated!</h1>
      <p className="mt-5 text-base md:text-lg text-white/85">
        You completed all 8 modules of <span className="font-bold text-white">Pathways to Employability</span>. That takes real commitment, and we're so proud of you.
      </p>
      <button onClick={onClose} className="mt-10 h-14 px-10 rounded-full bg-[#F2B705] text-[#4c124a] font-extrabold text-lg hover:bg-white transition-colors" data-testid="hc-graduation-continue">
        Continue
      </button>
    </div>
  </div>
);
